export default {
    countries: [],
    countriesWithEnterprises: [],
    countriesWithPhoneCodes: [],
};
